import { tryAcquire } from "async-mutex";
import React, { FC, useEffect, useState, memo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import Loading from "../ui/loading";
import MyTextInput from "../ui/myTextInput";
import { OneAPi } from "./oneApi";

type OwnProps = {
    onLogedIn: (loginparam: any) => void;
    hideLogin:boolean;
    onHideLogin: (hide:boolean)=>void;
}
const LoginOne789: FC<OwnProps> = ({
    onLogedIn,
    hideLogin,
    onHideLogin,
}) => {
    const [state, setState] = useState({
        userName: '',
        password: '',
        code: '',
        logedinResult: {} as any,
        isLoading: false,
        waitForCodeState: false,
        waitForUserNamePasswordState: true,
        
    })
    async function processLogin() {
        if (state.logedinResult.Session && state.waitForCodeState) {
            confirmLogin();
        } else {
            loginOne789();
        }
    }
    async function loginOne789() {
        setState(prev => ({ ...prev, isLoading: true }));
        const result = await OneAPi.login(state.userName, state.password);
        setState(prev => ({ ...prev, isLoading: false }));
        if (onLogedIn && result != undefined) {
            if (result.ChallengeName == 'SOFTWARE_TOKEN_MFA') {
                setState(prev => ({
                    ...prev, waitForCodeState: true, logedinResult: result,
                    waitForUserNamePasswordState: false,
                }))
            } else {
                onLogedIn(result);
                const tmp = { ...state };
                tmp.logedinResult = result;
                const str = JSON.stringify(tmp);
                localStorage['one789sign'] = str;
                setState(prev => ({
                    ...prev, logedinResult: result,
                    waitForUserNamePasswordState: false,
                }))
            }

        }
    }
    async function confirmLogin() {
        setState(prev => ({ ...prev, isLoading: true }));
        const result = await OneAPi.confirm(state.userName, state.logedinResult.Session, state.code);
        setState(prev => ({ ...prev, isLoading: false }));
        if (onLogedIn && result != undefined) {
            if (result.ChallengeName == 'SOFTWARE_TOKEN_MFA') {
                setState(prev => ({ ...prev, waitForCodeState: true }))
            } else {
                onLogedIn(result);
                const tmp = { ...state };
                tmp.logedinResult = result;
                const str = JSON.stringify(tmp);
                localStorage['one789sign'] = str;
                setState(prev => ({ ...prev, waitForCodeState: false }))
            }

        }
    }
    function isWaitForCode(): boolean {
        if (state.logedinResult.Session) {
            return true && state.waitForCodeState;
        }
        return false;
    }
    useEffect(() => {
        const savedData = localStorage['one789sign']
        if (savedData) {
            const savedObj = JSON.parse(savedData);
            setState(prev => ({ ...prev, userName: savedObj.userName, password: savedObj.password }))
        }
    }, [])
    if (state.isLoading)
        return <Loading />
    return <>
        {!hideLogin &&
            <div className=" form-content center">
                {state.waitForUserNamePasswordState && <div>
                    <MyTextInput label={"User name"} id={"id-username"}
                        inputClassName="full-width"
                        value={state.userName}
                        onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                            //set state
                            setState(prev => ({ ...prev, userName: e.target.value }))

                        }}></MyTextInput>
                    <MyTextInput isPassword label={"password"} id={"id-password"}
                        inputClassName="full-width"
                        value={state.password}
                        onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                            setState(prev => ({ ...prev, password: e.target.value }))
                        }}></MyTextInput>
                </div>}
                {
                    isWaitForCode() && <MyTextInput label={"Code"} id={"id-code"}
                        inputClassName="full-width"
                        value={state.code}
                        onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                            setState(prev => ({ ...prev, code: e.target.value }))
                        }}></MyTextInput>
                }
                {(state.waitForUserNamePasswordState || isWaitForCode()) &&
                    <div className=" common-container-row">
                        
                        <div>
                            <Button onClick={processLogin}> Đăng nhập</Button>
                        </div>
                        <div style='width:130px;'>
                            <Button onClick={() => {
                                onHideLogin(true)
                            }}>Ẩn</Button>
                        </div>
                    </div>
                }

            </div>
        }
    </>
}

export default memo(LoginOne789);